module.exports = __webpack_public_path__ + "img/16-ECS.54fa6f6.png";